import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const savedLang = localStorage.getItem("lang") || "fr";

i18n.use(initReactI18next).init({
  resources: {
    fr: {
      translation: {
        home: {
          welcome: "Bienvenue",
          login: "Se connecter",
          signup: "S'inscrire",
          email: "Email",
          password: "Mot de passe",
          forgot: "Mot de passe oublié ?",
          sendLink: "Envoyer le lien",
          unlockCode: "Code activation jeu (facultatif)",
          yourEmail: "Ton email",
          link: "Acheter le jeu",
        },
        profiles: {
          chooseProfile: "Choisis ton profil",
          edit: "Modifier",
          done: "Terminer",
          delete: "Supprimer",
          createProfile: "Créer un profil",
          editProfile: "Modifier le profil",
          pseudo: "Pseudo"
        },
        gameChoice: {
          title: "Choisis ton jeu",
          france: "La France",
          franceLocked: "La France 🔒",
          unlockPlaceholder: "Entrer un code d'extension",
          unlockButton: "Débloquer un jeu"
        },
        menu: {
          title: "Menu du jeu"
        },
        rules: {
          title: "Règles du jeu",
          content: "<p>Choisir son cépage 🌿 : Chaque joueur sélectionne son pion, de la couleur de son choix !</p>\
        <p></p>\
        <p>Faire tourner le pressoir 🎲 : À tour de rôle, les joueurs lancent le dé pour avancer sur le chemin de la vinification.</p>\
        <p></p>\
        <p>Déguster une carte 🍇 : Selon la case atteinte, le joueur pioche une carte correspondant à la thématique et à son millésime de connaissance :</p>\
        <ul>\
        <li>Primeur 🍷 (débutant)</li>\
        <li>Grand Cru 🏆 (amateur)</li>\
        <li>Millésime 👑 (expert)</li>\
        </ul>\
        <p></p>\
        <p>Faire mûrir sa réponse ❓ : Le joueur tente de répondre à la question de la carte. Par exemple : 'Quel est le principal cépage utilisé dans le Champagne ?'</p>\
        <p></p>\
        <p>Passer en barrique ou retourner à la vigne 🏡 :</p>\
        <ul>\
        <li>Si la réponse est correcte, le joueur reste en place et continue son voyage œnologique.</li>\
        <li>Si elle est incorrecte, il retourne à sa précédente étape, comme un vin qui doit vieillir un peu plus avant d’être parfait !</li>\
        </ul>\
        <p></p>\
        <p>Le tour passe au sommelier suivant 🍷 : C'est au joueur suivant de jouer !</p>\
        <p></p>\
        <p>🍾 Les Passages Secrets du Vigneron</p>\
        <p>Sur le plateau, certaines cases permettent d’accélérer ou de ralentir votre progression :</p>\
        <ul>\
        <li>Les Échelles de Vin 🍷🍇 : Vous tombez sur une case spéciale ? Bravo ! Comme un vin qui gagne en prestige, vous montez directement vers une case supérieure !</li>\
        <li>Tapis de levage pour raisins  🍷💦 : Attention aux accidents de vinification ! Si vous tombez sur la case, vous devrez revenir en arrière, comme un vigneron qui voit sa cuvée tourner au vinaigre… Mais si vous répondez bien à la question avec le niveau expert, alors le processus fait marche arrière !</li>\
        </ul>\
        <p></p>\
        <p>Objectif du Jeu 🏅 : Le premier joueur à atteindre la Corse devient Grand Maître du Chai et remporte la partie !</p>"
        },
        settings: {
          title: "Paramètres",
          soundSection: "🔊 Préférences sons",
          buttonSounds: "Activer les sons des boutons",
          timerSounds: "Activer les sons du timer",
          changePassword: "🔒 Changer mon mot de passe",
          legacy: "Mentions légales",
          alcoholWarning: "L’abus d’alcool est dangereux pour la santé, à consommer avec modération."
        },
        changePassword: {
          title: "Changer de mot de passe",
          oldPassword: "Mot de passe actuel",
          newPassword: "Nouveau mot de passe",
          confirmPassword: "Confirmer le nouveau mot de passe",
          submit: "Changer le mot de passe",
        },
        gameplay: {
          chooseCategory: "Choisis une thématique",
          chooseLevel: "Choisis un niveau",
          chooseDomain: "Choisis un domaine",
          ready: "Prêt ?",
          drawQuestion: "Tirer une question",
          timeLeft: "⏱ Temps restant : {{time}} sec",
          seeAnswer: "Voir la réponse",
          answer: "Réponse :",
          newQuestion: "Nouvelle question",
          loadError: "Impossible de charger une question."
        },
        categories: {
          history: "Histoire",
          geography: "Géographie",
          tasting: "Accords / Crus / Dégustation",
          jobs: "Métiers / Vinification",
          domains: "Domaines"
        },
        difficulties: {
          primeur: "Primeur",
          grandCru: "Grand Cru",
          vintage: "Millésime"
        },
        domains: {
          loire: "Val de Loire",
          champagne: "Champagne",
          alsace: "Alsace",
          bourgogne: "Bourgogne",
          beaujolais: "Beaujolais",
          rhone: "Vallée du Rhône",
          provence: "Provence",
          languedoc: "Languedoc-Roussillon",
          bordeaux: "Bordeaux",
          corsica: "Corse"
        },
        verify: {
          title: "Confirmation de l'email",
          loading: "Vérification en cours...",
          missingToken: "Token manquant",
          invalidToken: "Token invalide ou déjà utilisé",
          successMessage: "Email confirmé ! Tu peux maintenant te connecter.",
          serverError: "Erreur serveur, réessaie plus tard",
          backToLogin: "Retour à la connexion"
        },
        reset: {
            reset: "Réinitialiser ton mot de passe",
            change: "Changer le mot de passe",
            new: "Nouveau mot de passe",
            resetok : "Mot de passe réinitialisé !"
          },
        languages: {
          fr: "Français",
          en: "Anglais"
        },
        common: {
          save: "Sauvegarder",
          cancel: "Annuler"
        },
        errors: {
          login: "Email ou mot de passe incorrect",
          loginGeneric: "Erreur lors de la connexion",
          signup: "Erreur lors de l'inscription",
          signupGeneric: "Impossible de s'inscrire avec cet email ou code",
          forgot: "Erreur serveur",
          generic: "Une erreur est survenue",
          profilesFetch: "Erreur lors du chargement des profils",
          profileSave: "Impossible de sauvegarder le profil",
          profileDelete: "Impossible de supprimer le profil",
          fetchGames: "Impossible de récupérer les jeux débloqués",
          invalidCodeUsed: "Code invalide ou déjà utilisé",
          invalidCode: "Entrez un code valide",
          passwordMismatch: "Les mots de passe ne correspondent pas",
          serverError: "Erreur serveur, réessaie plus tard",
          
        },
        success: {
          passwordChanged: "Mot de passe changé avec succès"
        },
        info: {
          signupSuccess: "Compte créé. Vérifie ton email pour l’activer.",
          forgotSuccess: "Un email de réinitialisation a été envoyé !",
        },
      },
    },



    en: {
      translation: {
        home: {
          welcome: "Welcome",
          login: "Login",
          signup: "Sign up",
          email: "Email",
          password: "Password",
          forgot: "Forgot password?",
          sendLink: "Send link",
          unlockCode: "Game activation code (optional)",
          yourEmail: "Your email",
          link: "Buy the game",
        },
        profiles: {
          chooseProfile: "Choose your profile",
          edit: "Edit",
          done: "Done",
          delete: "Delete",
          createProfile: "Create profile",
          editProfile: "Edit profile",
          pseudo: "Nickname"
        },
        gameChoice: {
          title: "Choose your game",
          france: "France",
          franceLocked: "France 🔒",
          unlockPlaceholder: "Enter an extension code",
          unlockButton: "Unlock a game"
        },
        menu: {
          title: "Game menu"
        },
        rules: {
          title: "Game Rules",
          content:  "<p>Choose your grape variety 🌿: Each player selects their pawn, in the color of their choice!</p>\
          <p>Spin the press 🎲: Players take turns rolling the die to move forward along the winemaking path.</p>\
          <p>Draw a card 🍇: Depending on the space reached, the player draws a card related to a theme and to their level of wine knowledge:</p>\
          <ul>\
            <li>Primeur 🍷 (beginner)</li>\
            <li>Grand Cru 🏆 (intermediate)</li>\
            <li>Vintage 👑 (expert)</li>\
          </ul>\
          <p>Let your answer mature ❓: The player attempts to answer the question on the card. For example: \"What is the main grape variety used in Champagne?\"</p>\
          <p>Age in the barrel or return to the vineyard 🏡:</p>\
          <ul>\
            <li>If the answer is correct, the player stays in place and continues their oenological journey.</li>\
            <li>If the answer is incorrect, the player moves back to their previous position, like a wine that needs more time to mature!</li>\
          </ul>\
          <p>The turn passes to the next sommelier 🍷: It’s the next player’s turn!</p>\
          <p><strong>🍾 The Winemaker’s Secret Passages</strong></p>\
          <p>On the board, certain spaces allow you to speed up or slow down your progress:</p>\
          <ul>\
            <li>Wine Ladders 🍷🍇: You land on a special space? Congratulations! Like a wine gaining prestige, you immediately move up to a higher space.</li>\
            <li>Grape conveyor belts 🍷💦: Watch out for winemaking accidents! If you land here, you must move backward—unless you correctly answer an expert-level question, in which case the process reverses!</li>\
          </ul>\
          <p><strong>Game Objective 🏅:</strong> The first player to reach Corsica becomes the Grand Cellar Master and wins the game!</p>"
            },
        settings: {
          title: "Settings",
          soundSection: "🔊 Sound preferences",
          buttonSounds: "Enable button sounds",
          timerSounds: "Enable timer sounds",
          changePassword: "🔒 Change my password",
          legacy: "Legal notices",
          alcoholWarning: "Alcohol abuse is dangerous for your health. Please drink responsibly."
        },
        changePassword: {
          title: "Change Password",
          oldPassword: "Current password",
          newPassword: "New password",
          confirmPassword: "Confirm new password",
          submit: "Change Password"
        },
        gameplay: {
          chooseCategory: "Choose a category",
          chooseLevel: "Choose a level",
          chooseDomain: "Choose a domain",
          ready: "Ready?",
          drawQuestion: "Draw a question",
          timeLeft: "⏱ Time left: {{time}} sec",
          seeAnswer: "See answer",
          answer: "Answer:",
          newQuestion: "New question",
          loadError: "Unable to load a question."
        },
        categories: {
          history: "History",
          geography: "Geography",
          tasting: "Pairings / Crus / Tasting",
          jobs: "Jobs / Winemaking",
          domains: "Wine estates"
        },
        difficulties: {
          primeur: "Primeur",
          grandCru: "Grand Cru",
          vintage: "Vintage"
        },
        domains: {
          loire: "Val de Loire",
          champagne: "Champagne",
          alsace: "Alsace",
          bourgogne: "Bourgogne",
          beaujolais: "Beaujolais",
          rhone: "Vallée du Rhône",
          provence: "Provence",
          languedoc: "Languedoc-Roussillon",
          bordeaux: "Bordeaux",
          corsica: "Corse"
        },
          verify: {
            title: "Email confirmation",
            loading: "Verification in progress...",
            missingToken: "Missing token",
            invalidToken: "Invalid or already used token",
            successMessage: "Email confirmed! You can now log in.",
            serverError: "Server error, please try again later",
            backToLogin: "Back to login"
          },
          reset: {
            reset: "Reset your password",
            change: "Change your password",
            new: "New password",
            resetok : "Password reset!"
          },
        languages: {
          fr: "French",
          en: "English"
        },
        common: {
          save: "Save",
          cancel: "Cancel"
        },
        errors: {
          login: "Invalid email or password",
          loginGeneric: "Login error",
          signup: "Registration error",
          signupGeneric: "Unable to register with this email or code",
          forgot: "Server error",
          generic: "An error occurred",
          profilesFetch: "Failed to load profiles",
          profileSave: "Failed to save profile",
          profileDelete: "Failed to delete profile",
          fetchGames: "Unable to fetch unlocked games",
          invalidCodeUsed: "Invalid or already used code",
          invalidCode: "Enter a valid code",
          passwordMismatch: "Passwords do not match",
          serverError: "Server error, please try again later",
        },
        success: {
          passwordChanged: "Password changed successfully"
        },
        info: {
          signupSuccess: "Account created. Check your email to activate it.",
          forgotSuccess: "A reset email has been sent!",
        },
      },
    },
  },
  lng: savedLang,
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

export default i18n;
